import { CrudManager } from "./CrudManager";

export default function AdminFacilities() {
  return (
    <CrudManager
      testidPrefix="admin-facilities"
      title="Facilities"
      description="Manage hospital facilities highlighted on the home page."
      endpoint="/admin/facilities"
      columns={[
        { key: "name", label: "Name" },
        { key: "icon", label: "Icon" },
        { key: "description", label: "Description" },
      ]}
      emptyValues={{ name: "", icon: "Building2", description: "", image_url: "", highlights: [], order: 0 }}
      fields={[
        { name: "name", label: "Name", type: "text" },
        { name: "icon", label: "Lucide icon name", type: "text", placeholder: "Building2" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "image_url", label: "Image URL", type: "url" },
        { name: "highlights", label: "Highlights", type: "list" },
        { name: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
